import { Box } from '@mui/material';
import { menuItems } from 'constants/';
import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { CustomNavbar, DefaultNavbar } from './';
import { MenuItem } from 'types/MenuItem';
import { Footer, UserAvailability } from '..';
import { useBookingTimer } from 'context/BookingTimerContext';

export const Layout: React.FC<{
  children: React.ReactNode;
  locationCode: string;
}> = ({ children }) => {
  const queryParams = new URLSearchParams(window.location.search);
  let locationCode = queryParams.get('locationCode') || 'da3';
  const [openuserAvailability, setOpenUserAvailability] =
    useState<boolean>(false);
  const [userAvailabilityLeftTime, setUserAvailabilityLeftTime] =
    useState<number>(60);
  const location = useLocation();

  function useCurrentRoute(menuItems: any[]) {
    const currentRoute = menuItems.find((item: MenuItem) => {
      return item.path.split('/')[1] == location.pathname.split('/')[1];
    });

    return currentRoute;
  }

  const currentRoute = useCurrentRoute(menuItems);
  const { timeLeft } = useBookingTimer();

  const handleClose = () => {};
  if (openuserAvailability)
    return (
      <UserAvailability
        open={openuserAvailability}
        setOpenuserAvailability={setOpenUserAvailability}
        remainingTime={userAvailabilityLeftTime}
        handleClose={handleClose}
        setUserAvailabilityLeftTime={setUserAvailabilityLeftTime}
      />
    );

  const renderNavbar = () => {
    if (!currentRoute || !currentRoute.navbar) return undefined;
    const dynamicLogo: string = location.pathname === '/' ? 'home' : 'menu';
    switch (currentRoute.navbar) {
      case 'default':
        return <DefaultNavbar logo={dynamicLogo} />;
      case 'custom':
        return <CustomNavbar title={currentRoute.title} />;
      default:
        return undefined;
    }
  };

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}
      className={''}
    >
      {renderNavbar()}
      <Box
        component="main"
        flexGrow={1}
        sx={{ flex: 1, overflowY: 'auto', marginBottom: '0px' }}
      >
        {children}
      </Box>
      {!['vehicle-addons', 'payment-option', 'document-upload'].includes(
        location.pathname.split('/')[1]
      ) && <Footer bookingScreenTime={timeLeft} />}
    </Box>
  );
};
